
import { Button, Box } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
/* Always will pass as parameter the ID of the clicked column */
const NewOpportunityButton = ({ buttonClicked }) => {

    return (
        <>
            <Button
                sx={{ width: '100%' }}
                variant='contained'
                onClick={({ currentTarget }) => buttonClicked(currentTarget.parentElement?.parentElement?.attributes['data-rbd-draggable-id']?.value.replace('column-draggable-', ''))}
            >
                <AddIcon />
                <Box sx={{paddingTop: '.25rem'}}>Nova Oportunidade</Box>
            </Button>
        </>
    )
}

export default NewOpportunityButton